import { P500UIButtonsModule, P500UIIconsModule, P500UINotificationsModule } from '@platform500services/p500-ui-kit';

import { BaseLayoutComponent } from './base.layout';
import { CommonModule } from '@angular/common';
import { CopyrightModule } from '../../components/copyright/copyright.module';
import { KnowledgeBaseModule } from '../../components/knowledge-base/knowledge-base.module';
import { NavPanelModule } from '../../components/nav-panel/nav-panel.module';
import { Inject, NgModule } from '@angular/core';
import { RefreshModule } from '../../directives/refresh/refresh.module';
import { RouterModule } from '@angular/router';
import { SidebarModule } from '../../components/sidebar/sidebar.module';
import { TopBarModule } from '../../components/top-bar/top-bar.module';
import { UnsecuredBarModule } from '../../components/unsecured-bar/unsecured-bar.module';
import { WebPushService } from '../services/web-push.service';
import { NotificationsSidebarModule } from '../../components/notifications-sidebar/notifications-sidebar.module';
import { InfoModalModule } from '../../modals/info/info.module';
import { MetricInfoModalModule } from '../../modals/metric-info/metric-info.module';
import { OfflinePageComponent } from '../../components/offline-page/offline-page.component';
import { BrowserWindowRef } from '../../services/window/window.service';
import { fromEvent } from 'rxjs';
import { first } from 'rxjs/operators';
import { NewVersionModalModule } from '../../modals/new-version/new-version.module';
import { AnalyticsComponent } from '../../components/analytics/analytics.component';

@NgModule({
  imports: [
    CommonModule,
    P500UINotificationsModule,
    P500UIIconsModule,
    P500UIButtonsModule,
    RouterModule,
    KnowledgeBaseModule,
    CopyrightModule,
    TopBarModule,
    NavPanelModule,
    SidebarModule,
    RefreshModule,
    UnsecuredBarModule,
    NotificationsSidebarModule,
    InfoModalModule,
    MetricInfoModalModule,
    OfflinePageComponent,
    NewVersionModalModule,
    AnalyticsComponent,
  ],
  declarations: [BaseLayoutComponent],
  exports: [BaseLayoutComponent],
  providers: [
    {
      provide: 'IWebPushService',
      useClass: WebPushService,
    },
    BrowserWindowRef,
  ],
})
export class BaseModule {
  constructor(@Inject(BrowserWindowRef) private window: BrowserWindowRef) {
    fromEvent(this.window.nativeWindow, 'beforeinstallprompt')
      .pipe(first())
      .subscribe(($event) => {
        this.window.nativeWindow.installPwaEvent = $event;
      });
  }
}
